import { UserTutorBookingListItem } from '../models/Tutor';
import { isOnlinePaymentHold } from './seriesAcceptPlan';
import { isTutorBookingModeratable } from './tutorBookingStatus';

export type UserTutorBookingDisplayRow =
  | { kind: 'single'; booking: UserTutorBookingListItem }
  | { kind: 'series'; seriesId: string; bookings: UserTutorBookingListItem[] };

type UserTutorSeriesCandidate = {
  recurringSeriesId?: string | null;
  status?: string | null;
  paymentStatus?: string | null;
  startTime?: string | null;
};

/** Pending lessons that still share one card hold. Cash stays one card each. */
export function userTutorBookingGroupsAsPendingSeries(booking: UserTutorSeriesCandidate): boolean {
  const seriesId = booking.recurringSeriesId?.trim();
  if (!seriesId) return false;
  if (!isTutorBookingModeratable(booking.status)) return false;
  return isOnlinePaymentHold(booking.paymentStatus);
}

export function userTutorCancelReleasesSeries(booking: UserTutorSeriesCandidate): boolean {
  return userTutorBookingGroupsAsPendingSeries(booking);
}

export function groupUserTutorBookings(
  items: UserTutorBookingListItem[],
): UserTutorBookingDisplayRow[] {
  if (items.length === 0) return [];
  const bySeries = new Map<string, UserTutorBookingListItem[]>();
  for (const booking of items) {
    if (!userTutorBookingGroupsAsPendingSeries(booking)) continue;
    const seriesId = booking.recurringSeriesId!.trim();
    const list = bySeries.get(seriesId);
    if (list) list.push(booking);
    else bySeries.set(seriesId, [booking]);
  }
  Array.from(bySeries.values()).forEach((list) => {
    list.sort((a, b) => (a.startTime || '').localeCompare(b.startTime || ''));
  });
  const seriesIds = new Set(
    Array.from(bySeries.entries())
      .filter((entry) => entry[1].length >= 2)
      .map((entry) => entry[0]),
  );
  const emitted = new Set<string>();
  const out: UserTutorBookingDisplayRow[] = [];
  for (const booking of items) {
    const seriesId = booking.recurringSeriesId?.trim();
    const grouped =
      seriesId != null &&
      seriesIds.has(seriesId) &&
      userTutorBookingGroupsAsPendingSeries(booking);
    if (grouped) {
      if (!emitted.has(seriesId)) {
        emitted.add(seriesId);
        out.push({
          kind: 'series',
          seriesId,
          bookings: bySeries.get(seriesId)!,
        });
      }
    } else {
      out.push({ kind: 'single', booking });
    }
  }
  return out;
}
